/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import "./styles/css/signup.css";
import { Button, Segment, Form, Header, Label, Icon, Image } from "semantic-ui-react";
import { Input, FreeForm, FormRow, Dropdown } from "kx-common-components";
import { Redirect, Link } from "react-router-dom";
import API from "../utility/API";
import { get } from "lodash";
import Logo from "../media/newlogo2.png";

class Signup extends Component {
  constructor() {
    super();
    this.state = {
      companyName: "",
      email: "",
      contactName: "",
      error: false
    };
  }

  componentWillMount = () => {
    this.props.setBackground('mainContainer')
    const pathArray = window.location.pathname.split("/")
    const type = pathArray[2]
    this.setState({
      typeOfUser: type === 'importer' ? 'CUSTOMER_USER' : type === 'ff' ? 'FREIGHT_FORWARDER' : type === 'channel' ? 'CHANNEL_USER' : ''
    })

  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleUpdate(key, e) {
    this.setState({ [key]: e });
  }

  handleSubmit = () => {
    const { companyName, email, contactName, typeOfUser, error } = this.state;

    this.setState({ companyName, email, contactName, error: false }, console.log(this.state));

    if(companyName === ""){
      let msg = "A company name is required for signup."
      document.getElementById('loginError').innerHTML = `<br /><center> ${msg} </center>`
    } else if(contactName === ""){
      let msg = "A contact name is required for signup."
      document.getElementById('loginError').innerHTML = `<br /><center> ${msg} </center>`
    }
    else{
    API.createCustomer(companyName, email, typeOfUser === 'CHANNEL_USER' ? 'FREIGHT_FORWARDER' : typeOfUser , contactName)
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        console.log('signup.js', responseData)
        if (responseData.eventMessage.header.code === 400)  {
          let msg= responseData.eventMessage.header.msg === 'Error : Email not allowed' ? 'Please enter email with approved domain.' : responseData.eventMessage.header.msg === 'Error : User already exists...' ? 'User with email already exists.' : responseData.eventMessage.header.msg
          console.log('400')
          document.getElementById('loginError').innerHTML = `<br /><center> ${msg} </center>`
          this.setState({ error: true })
        }
      })
      .then(() => {
        if (!this.state.error) {
          this.setState({ toNextPage: true })
          this.props.setBackground('grayBackground')
        }
      })
      .catch((err) => console.log("ERROR:", err));
  }
};

  render() {
    const displayText = {
      CUSTOMER_USER: 'an Importer',
      FREIGHT_FORWARDER: 'a Freight Forwarder',
      CHANNEL_USER: 'a Channel'
    }
    const { companyName, email, contactName, toNextPage, typeOfUser} = this.state;

    if (toNextPage === true) {
      return <Redirect to="/thanks" />;
    }

    return (
      <Segment padded="very" className="signup-container">
        <p className="login-header">Register as {displayText[typeOfUser]}</p>

        <div className="login-form">
          <FreeForm>
            <FormRow>
              <Input onChange={(e) => this.handleUpdate("companyName", e)} label={"COMPANY"} singleElement topElement />
            </FormRow>
            <FormRow>
              <Input onChange={(e) => this.handleUpdate("contactName", e)} label={"FULL NAME"} singleElement />
            </FormRow>
            <FormRow>
              <Input onChange={(e) => this.handleUpdate("email", e)} label={"EMAIL"} singleElement bottomElement />
            </FormRow>
          </FreeForm>

          <Button className="login-button" onClick={() => this.handleSubmit()}>
            SIGN UP
          </Button>

          <div id='loginError'></div>

          <center>
            <p>
              Already have an account? <Link to="/">Log in</Link>
            </p>
          </center>
        </div>
      </Segment>
    );
  }
}

export default Signup;